import React from 'react';
import { ServiceType } from '@bookpeazy/common-js';
import ServiceTypeCardGrid from '../ServiceTypeCardGrid';

type ServiceTypeSelectProps = {
  help?: string;
  types: ServiceType[];
  onSelect: () => void;
  value: ServiceType | null;
  onChange: (value: ServiceType) => void;
  error?: string;
  touched?: boolean;
}

const ServiceTypeSelectField: React.FC<ServiceTypeSelectProps> = ({
  help,
  types,
  onSelect,
  value,
  onChange,
  error,
  touched,
}) => {
  const handleServiceClick = (selectedService: ServiceType) => {
    onChange(selectedService);
    onSelect();
  };

  return (
    <div>
      <ServiceTypeCardGrid
        types={types}
        onServiceClick={handleServiceClick}
        value={value}
      />
      <span className={`text-sm ${touched && error ? 'error' : ''}`}>
        {touched && error ? error : help}
      </span>
    </div>
  );
};

export default ServiceTypeSelectField;
